import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=3fa8afd3&scoped=true&"
import script from "./ModalWindow.vue?vue&type=script&lang=ts&"
export * from "./ModalWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=3fa8afd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8afd3",
  null
  
)

export default component.exports